import { ClickAwayListener, Popper } from "@mui/material";
import ExpandMoreSharpIcon from '@mui/icons-material/ExpandMoreSharp';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import React from "react";
import styles from "./layout.module.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout, setAuth } from "../../apis/reducers/authReducer";
import { LOCALSTORAGE } from "../../libs/constants";
import { RootState } from "../../apis/store";
import SnackbarMessage from "./Snackbar";


const Layout = (props: LayoutProps) => {
  const { children, withBreadcrumbs, bgColor } = props;
  const dispatch = useDispatch();
  const { page, } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const username = useSelector((state: RootState) => state.auth.userName);
  const [logoutEl, setLogoutEl] = React.useState<HTMLButtonElement | null>(null);
  const [openLogout, setOpenLogout] = React.useState(false);


  React.useEffect(() => {
    if (localStorage && localStorage.getItem(LOCALSTORAGE.token)) {
      const token = localStorage.getItem(LOCALSTORAGE.token)
        if (token) {
          dispatch(setAuth());
        }
    } else {
        navigate("/login");
    }
}, [])

  return (
    <div className={styles.layout} style={{backgroundColor: bgColor && bgColor !== undefined ? bgColor : ""}}>
      <div className={styles.header}>
        <div className={withBreadcrumbs ? `${styles.header__left} ${styles.with_bc}` : `${styles.header__left}`}>
          {
            withBreadcrumbs ?
            <>
              <div onClick={() => navigate("../brandlist")}>ブランド一覧</div>
              <KeyboardArrowRightRoundedIcon color="primary"/>
              <div className={styles.selected}>
                { location.pathname.includes("/brand/") ? "請求一覧" : "請求内容" }
              </div>
            </> :
            <>
              <div className={page === "dashboard" ? `${styles.selected}` : ""} onClick={() => navigate("../dashboard")}>ダッシュボード</div>
              <div className={page === "brandlist" ? `${styles.selected}` : ""} onClick={() => navigate("../brandlist")}>ブランド一覧</div>
            </>
          }
        </div>
        <div className={styles.header__right}>
          <button 
            className={styles.PageTopP} 
            onClick={(e) => {setOpenLogout(true); setLogoutEl(e.currentTarget)}}>
              <span>{username}</span>
              <ExpandMoreSharpIcon style={{"width": "30px", "height": "20px"}} color="primary"/>
          </button>
        </div>
      </div>
      <React.Fragment>
        {children}
        <SnackbarMessage/>
      </React.Fragment>
      <Popper open={openLogout} anchorEl={logoutEl}>
          <ClickAwayListener onClickAway={() => setOpenLogout(false)}>
              <div className={styles.logout} onClick={() => {dispatch(logout()); navigate("/login")}}>ログアウト</div>
          </ClickAwayListener>
      </Popper>
    </div>
  )
}

export default Layout;

export type LayoutProps = {
  children: any;
  withBreadcrumbs: boolean;
  bgColor?:string;
}